
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import ReferralsOverviewPanel from '@/components/business/ReferralsOverviewPanel';
import ReferralActivityChart from '@/components/business/ReferralActivityChart';
import { useAdminDashboardAnalytics } from '@/hooks/useAdminDashboardAnalytics';
import DashboardStatsSection from '@/components/business/DashboardStatsSection';

const AdminDashboardAnalytics: React.FC = () => {
  const { analyticsData, isLoading } = useAdminDashboardAnalytics();
  
  if (isLoading) {
    return (
      <div className="grid gap-4 md:gap-8 animate-pulse">
        <div className="h-32 bg-gray-200 rounded-lg"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="h-80 bg-gray-200 rounded-lg"></div>
          <div className="h-80 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    );
  }
  
  // Transform data for the stats section
  const dashboardStats = {
    totalUsers: 1250,
    activeUsers: 873,
    totalReferrals: analyticsData.referralStats.total,
    revenue: 15240
  };

  return (
    <div className="space-y-8">
      <DashboardStatsSection stats={dashboardStats} />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <ReferralsOverviewPanel 
          totalReferrals={analyticsData.referralStats.total}
          pendingReferrals={analyticsData.referralStats.pending}
          approvedReferrals={analyticsData.referralStats.approved}
          completedReferrals={analyticsData.referralStats.completed}
        />
        
        <ReferralActivityChart chartData={analyticsData.monthlyActivity} />
      </div>
    </div>
  );
};

export default AdminDashboardAnalytics;
